import React from 'react';
import { InspectionListItemProps } from './InspectionList.types';
import { Badge } from '../Badge/Badge';
import { getStatusText } from '../Badge';

const InspectionListItem: React.FC<InspectionListItemProps> = ({
  item,
  isSelected = false,
  onHover,
  onClick,
  onFocus,
  onKeyDown,
}) => {
  const handleMouseEnter = () => {
    onHover?.(item);
  };

  const handleClick = () => {
    onClick?.(item);
  };

  const handleFocus = () => {
    onFocus?.(item);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.(item);
    }
    onKeyDown?.(event, item);
  };

  {
    /* TODO: to jest do poprawienia - skopane CSS */
  }
  return (
    <div
      role="listitem"
      tabIndex={0}
      aria-selected={isSelected}
      aria-describedby={`${item.id}-description`}
      className={`flex overflow-hidden flex-col flex-wrap gap-4 items-center p-4 w-full bg-white rounded-2xl border border-solid transition-all duration-200 md:p-0 md:flex-row min-h-[68px] max-md:max-w-full md:gap-0`}
      onMouseEnter={handleMouseEnter}
      onClick={handleClick}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
    >
      <div className="flex md:min-w-60 md:max-w-[418px] justify-center flex-1 md:shrink md:basis-0 items-center md:justify-start gap-5 md:self-stretch md:border-r border-zinc-200 pl-7 pr-5 text-base font-semibold leading-none text-zinc-800 max-md:pl-5 text-center md:text-left">
        {item.name}
      </div>

      <div className="flex md:w-[216px]  items-center justify-center self-stretch whitespace-nowrap md:border-r border-zinc-200 text-base font-bold uppercase leading-none">
        {item.customBadge || (
          <Badge
            variant={item.status}
            badgeText={item.badgeCustomText || getStatusText(item.status)}
            classNames="self-center"
            version="v2"
          />
        )}
      </div>

      <div
        className="flex flex-1 justify-center items-center pr-7 pl-5 mx-auto text-sm leading-4 text-center text-gray-500 md:justify-start md:self-stretch md:min-w-60 shrink basis-0 border-zinc-200 max-md:max-w-full max-md:pr-5 md:text-left"
        id={`${item.id}-description`}
        aria-label={`Komentarze: ${item.comments}`}
      >
        {item.comments}
      </div>
    </div>
  );
};

export default InspectionListItem;
